var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "rotate(90 15.5 15.5)",
    fill: "#8A49D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0063 17.924C21.0573 17.924 20.1255 17.7756 19.2426 17.4838C18.8099 17.3362 18.278 17.4716 18.0139 17.7428L16.2711 19.0584C14.25 17.9795 13.0049 16.7349 11.9408 14.7289L13.2177 13.0315C13.5495 12.7002 13.6685 12.2162 13.5259 11.7621C13.2328 10.8745 13.084 9.94317 13.084 8.99379C13.084 8.30796 12.5261 7.75 11.8403 7.75H8.99375C8.30796 7.75 7.75 8.30796 7.75 8.99375C7.75 16.8548 14.1453 23.25 22.0063 23.25C22.6921 23.25 23.25 22.692 23.25 22.0062V19.1677C23.25 18.4819 22.692 17.924 22.0063 17.924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 15.5,
    fill: "white",
    transform: "translate(7.75 7.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneContact);
export default __webpack_public_path__ + "static/media/Phone-Contact.3099117a749ed62ffde169bcbea8e31c.svg";
export { ForwardRef as ReactComponent };